import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import "../MyProfileAddBussiness/myProfileAddBussiness.css";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { AddBusinessUser } from "../../Utils/Api/AddBusinessUser";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft } from "react-icons/md";

function MyProfileAddBussiness() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let err = {};

    if (!email.trim()) {
      err.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      err.email = "Enter a valid email address";
    }

    if (!password.trim()) {
      err.password = "Password is required";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  // ADD BUSINESS → SEND OTP
  const handleVerify = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    const payload = {
      link_business_email: email.trim(),
      link_business_password: password.trim(),
      primary_bu_id: 1, // ✅ FIXED KEY
    };

    const response = await AddBusinessUser(payload);

    if (response === false) {
      toast.error("Server error. Please try again.", {
        position: "top-center",
        theme: "dark",
      });
      setLoading(false);
      return;
    }

    if (response.success === true) {
      toast.success("Verification code sent successfully!", {
        position: "top-center",
        theme: "dark",
      });

      // ✅ PASS CORRECT STATE KEYS
      navigate("/my-profile/addbusiness/otp", {
        state: {
          link_business_email: email.trim(),
          primary_bu_id: 1,
        },
      });
    } else {
      toast.error(response.message || "Unable to add business", {
        position: "top-center",
        theme: "dark",
      });
    }

    setLoading(false);
  };

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>

        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/my-profile/manage-business"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">Add Business</p>

          <div className="acc-dashboard mt-4">
            <Row>
              <Col md={3} />
              <Col md={6}>
                <form
                  className="add_bussiness_form"
                  noValidate
                  onSubmit={handleVerify}
                >
                  {/* EMAIL */}
                  <label className="form-label-custom">
                    Email address <span className="star-required">*</span>
                  </label>

                  <input
                    type="email"
                    className="form_control_add_bussiness"
                    placeholder="Enter Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && (
                    <small className="text-danger">{errors.email}</small>
                  )}

                  {/* PASSWORD */}
                  <div className="mt-3 position-relative">
                    <label className="form-label-custom">
                      Password <span className="star-required">*</span>
                    </label>

                    <input
                      type={showPassword ? "text" : "password"}
                      className="form_control_add_bussiness"
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />

                    <span
                      className="password-eye"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>

                    {errors.password && (
                      <small className="text-danger d-block">
                        {errors.password}
                      </small>
                    )}
                  </div>

                  {/* BUTTON */}
                  <div className="mt-4 text-start">
                    <Button
                      type="submit"
                      className="add_business_verify"
                      disabled={loading}
                    >
                      {loading ? (
                        <RotatingLines strokeColor="white" width={20} />
                      ) : (
                        "Verify"
                      )}
                    </Button>
                  </div>
                </form>
              </Col>
              <Col md={3} />
            </Row>
          </div>
        </div>
      </div>

      <PrivacyTermsConditions />
    </>
  );
}

export default MyProfileAddBussiness;
